import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { empty } from '../../functions';
import { CompanyService } from '../../shared/services/company.service';
import {
  faMapMarkerAlt,
  faDownload,
  faSearch,
  faLink,
  faUnlink,
  faBinoculars,
  faFileContract,
  faExternalLinkAlt,
  faInfoCircle,
  faPlus,
  faTimes,
  faClock,
  faCalendarTimes,
  faGraduationCap,
  faHeart,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faGoogle,
} from '@fortawesome/free-brands-svg-icons';
import { faHeart as farHeart } from '@fortawesome/free-regular-svg-icons';
import { JobService } from '../../shared/services/job.service';
import { ModelJobposting } from '../../model/model.jobposting';
import { catchError } from 'rxjs/operators';
import { UserService } from '../../shared/services/user.service';
import { RoleTypes } from '../../guards/roletypes';
import { ModalStudentApplyComponent } from '../../student/modal-student-apply/modal-student-apply.component';
import { ModalService } from '../../shared/services/modal.service';
import { DomainService } from '../../shared/services/domain.service';

@Component({
  selector: "app-assignment-profile",
  templateUrl: "./assignment-profile.component.html",
  styleUrls: ["./assignment-profile.component.scss"],
  standalone: false,
})
export class AssignmentProfileComponent implements OnInit {
  isLoading = signal(false);
  isProcessing = false;

  RoleTypes = RoleTypes;

  faSearch = faSearch;
  faMapMarkerAlt = faMapMarkerAlt;
  faFacebookF = faFacebookF;
  faLinkedinIn = faLinkedinIn;
  faXTwitter = faXTwitter;
  faLink = faLink;
  faUnlink = faUnlink;
  faBinoculars = faBinoculars;
  faInfoCircle = faInfoCircle;
  faPlus = faPlus;
  faGoogle = faGoogle;
  faTimes = faTimes;
  faClock = faClock;
  faCalendarTimes = faCalendarTimes;
  faGraduationCap = faGraduationCap;
  faExternalLinkAlt = faExternalLinkAlt;
  faFileContract = faFileContract;
  faDownload = faDownload;
  faHeart = faHeart;
  farHeart = farHeart;

  public entity: ModelJobposting = {
    id: "",
    companyId: "",
    company: {
      id: "",
      status: "",
      name: "",
      registrationNumber: "",
      visitAddress: {
        street: "",
        number: "",
        numberSuffix: "",
        city: "",
        postalCode: "",
        country: "",
      },
      phoneNumber: "",
      address_city: "",
      description: "",
      descriptionEn: "",
      descriptionDe: "",
      descriptionFr: "",
      descriptionPt: "",
      uniqueText: "",
      uniqueTextEn: "",
      uniqueTextDe: "",
      uniqueTextFr: "",
      uniqueTextPt: "",
      opportunitiesText: "",
      opportunitiesTextEn: "",
      opportunitiesTextDe: "",
      opportunitiesTextFr: "",
      opportunitiesTextPt: "",
      sectorId: "",
      sectorName: "",
      numberOfEmployees: "",
      websiteUri: "",
      twitterUri: "",
      facebookUri: "",
      linkedInUri: "",
      instagramUri: "",
      googleUri: "",
      avatarUri: "",
      coverPhotoUri: "",
      isCurrentUserFavorite: false,
    },
    trademarkId: "",
    trademark: {
      id: "",
      name: "",
      description: "",
      avatarUri: "",
      coverPhotoUri: "",
    },
    contactPersonId: "",
    contactPerson: {
      id: "",
      emailAddress: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
    },
    isCurrentUserFavorite: false,
    currentUserMatchPercentage: 0,
    title: "",
    location: "",
    description: "",
    address: {
      street: "",
      number: "",
      numberSuffix: "",
      postalCode: "",
      city: "",
      country: "",
    },
    requirements: "",
    termsOfEmployment: "",
    additionalInfo: "",
    immediatelyAvailable: false,
    startDate: "",
    deadline: "",
    hours: "",
    hoursPerWeek: 0,
    isExperienceDesired: false,
    externalReferenceUri: "",
    status: "",
    type: "",
    areaOfInterests: <any>[],
    educationLevels: <any>[],
    documents: <any>[],
    related_jobs: <any>[],
    regions: [],
    jobPostingTargetGroups: [],
  };

  constructor(
    public route: ActivatedRoute,
    public companyService: CompanyService,
    public userService: UserService,
    public jobService: JobService,
    private domain: DomainService,
    private modal: ModalService
  ) {}

  /**
   * Ng init
   */
  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const id: string = <string>params.get("id");
      if (!empty(id)) {
        this.getData(id);
      }
    });
  }

  /**
   * Get profile data
   *
   * @param id
   */
  getData(id: string) {
    this.isLoading.set(true);

    this.jobService.apiGetJobPosting(id).subscribe((result: any) => {
      this.isLoading.set(false);

      if (!empty(result)) {
        this.entity = Object.assign(<ModelJobposting>{}, result);
      }
    });
  }

  /**
   * Add a company as favorite
   */
  addCompanyAsFavorite() {
    if (this.entity.company.id) {
      this.isProcessing = true;

      this.companyService
        .apiAddCompanyFavorite(this.entity.company.id)
        .pipe(
          catchError(
            this.companyService.handleError("apiAddCompanyFavorite", false)
          )
        )
        .subscribe((result) => {
          this.isProcessing = false;

          if (result !== false) {
            this.entity.company.isCurrentUserFavorite =
              !this.entity.company.isCurrentUserFavorite;
          }
        });
    }
  }

  /**
   * Delete a company as favorite
   */
  deleteCompanyAsFavorite() {
    if (this.entity.company.id) {
      this.isProcessing = true;
      this.companyService
        .apiDeleteCompanyFavorite(this.entity.company.id)
        .pipe(
          catchError(
            this.companyService.handleError("apiDeleteCompanyFavorite", false)
          )
        )
        .subscribe((result) => {
          this.isProcessing = false;

          if (result !== false) {
            this.entity.company.isCurrentUserFavorite =
              !this.entity.company.isCurrentUserFavorite;
          }
        });
    }
  }

  /**
   * Add job posting as favorite to current user
   *
   * @param id
   */
  addJobPostingToFavorite(id: string) {
    this.isProcessing = true;

    this.jobService
      .apiAddJobPostingFavorite(id)
      .pipe(
        catchError(
          this.jobService.handleError("apiAddJobPostingFavorite", false)
        )
      )
      .subscribe((result) => {
        this.isProcessing = false;

        if (result !== false) {
          this.entity.isCurrentUserFavorite =
            !this.entity.isCurrentUserFavorite;
        }
      });
  }

  /**
   * Add job posting as favorite to current user
   *
   * @param id
   */
  deleteJobPostingToFavorite(id: string) {
    this.isProcessing = true;

    this.jobService
      .apiDeleteJobPostingFavorite(id)
      .pipe(
        catchError(
          this.jobService.handleError("apiDeleteJobPostingFavorite", false)
        )
      )
      .subscribe((result) => {
        this.isProcessing = false;

        if (result !== false) {
          this.entity.isCurrentUserFavorite =
            !this.entity.isCurrentUserFavorite;
        }
      });
  }

  /**
   * Apply for job posting
   *
   * @param id
   */
  applyForJobPosting(id: string) {
    const modalOptions = {
      size: "xl",
      backdrop: "static",
    };

    const data = {
      jobposting: {
        id: id,
      },
    };

    // Show apply modal
    this.modal
      .Modal(ModalStudentApplyComponent, "", "", data, [], modalOptions)
      .then(() => {})
      .catch((error) => {});
  }

  /**
   * Get a share link for a social media provider
   *
   * @param provider
   */
  getSocialShareLink(provider: string) {
    let url = "";
    const link = this.domain.getCurrentDomain().url + "/jobs/" + this.entity.id;
    switch (provider) {
      case "facebook":
        url +=
          "https://www.facebook.com/share.php?u=" +
          link +
          "&title=" +
          this.entity.title;
        break;

      case "twitter":
        url +=
          "https://twitter.com/intent/tweet?url=" +
          link +
          "&text=" +
          this.entity.title;
        break;

      case "linkedin":
        url += "https://www.linkedin.com/sharing/share-offsite/?url=" + link;
        break;
    }

    return url;
  }
}
